import styled from "styled-components";
import WIOSSLoader from "../../interface/WIOSSLoader";
import { ProgressTubeBar } from "../../interface/ProgressTubeBar";

const NoContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

function Dispatch() {
  return (
    <NoContentContainer>
      <WIOSSLoader text="SOMETHING IN THE FUTURE HERE" />
    </NoContentContainer>
  );
}

export default Dispatch;
